import AudioPool from "./AudioPool";
import VFXPool from "./VFXPool";
import TweenPool from "./TweenPool";

/**
 * Lightweight Pool Coordinator
 * Single Responsibility: Coordinate access to individual pools
 */
export default class PoolCoordinator {
  // Individual pools - each with their own single responsibility
  readonly audioPool: AudioPool;
  readonly vfxPool: VFXPool;
  readonly tweenPool: TweenPool;

  constructor(scene: Phaser.Scene) {
    this.audioPool = new AudioPool(scene);
    this.vfxPool = new VFXPool(scene);
    this.tweenPool = new TweenPool(scene);
  }

  /**
   * Clean shutdown - only responsibility is coordinating cleanup
   */
  destroy(): void {
    this.audioPool.destroy();
    this.vfxPool.destroy();
    this.tweenPool.destroy();
  }
}
